import React from 'react';

const VerdiIcon = ({ width = '24', height = '24' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.967 16.227"
    >
      <defs>
        <style>{`.VerdiIconClass{fill:transparent;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.5px;}`}</style>
      </defs>
      <g
        id="Group_4637"
        data-name="Group 4637"
        transform="translate(-37.752 -255.375)"
      >
        <g
          id="Money-Payments-Finance_Currencies_currency-dollar-increase"
          data-name="Money-Payments-Finance / Currencies / currency-dollar-increase"
          transform="translate(-215.5 -294.625)"
        >
          <g id="Group_65" transform="translate(253 551)">
            <g id="currency-dollar-increase">
              <path
                className="VerdiIconClass"
                id="Shape_215"
                d="M255.234,578.809a.309.309,0,0,0-.309-.309h-3.093a.309.309,0,0,0-.219.528l.875.875a.156.156,0,0,1,.045.113.154.154,0,0,1-.049.111l-2.835,2.613a.154.154,0,0,1-.2.007l-1.794-1.433a1.332,1.332,0,0,0-1.714.044l-.135.12-4.524,4.02a.773.773,0,0,0,1.027,1.157l4.425-3.934a.155.155,0,0,1,.2-.005l1.794,1.437a1.339,1.339,0,0,0,1.735-.062l3.122-2.878a.155.155,0,0,1,.215,0l.9.9a.309.309,0,0,0,.532-.22Z"
                transform="translate(-240.39 -572.006)"
                fill="none"
                stroke="black"
                strokeWidth="0.5"
              />
            </g>
          </g>
        </g>
        <g
          className="VerdiIconClass"
          id="Group_4636"
          data-name="Group 4636"
          transform="translate(-2520.5 -109.625)"
        >
          <g
            className="VerdiIconClass"
            id="Ellipse_931"
            data-name="Ellipse 931"
            transform="translate(2558.5 365)"
            fill="#fff"
            stroke="black"
            strokeWidth="0.5"
          >
            <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
            <circle cx="4.5" cy="4.5" r="4.125" fill="none" />
          </g>
          <text
            className="VerdiIconClass"
            id="kr"
            transform="translate(2561 371)"
            fill="black"
            fontSize="5"
            fontFamily="SofiaPro-SemiBold, Sofia Pro"
            fontWeight="300"
          >
            <tspan x="0" y="0">
              kr
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default VerdiIcon;
